const store = {
    state: {
        regionDatasource: []
    },
    setRegionDatasource: function (data) {
        this.state.regionDatasource = data;
    }
};
export {store};
